"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class InvalidStorageProvider extends Error {
  constructor(message) {
    super(message);
  }

  static invalid() {
    return new InvalidStorageProvider('Storage provider invalid');
  }

  static missingProperty(property) {
    return new InvalidStorageProvider(`Interface property ${property} not implmemented`);
  }

}

exports.default = InvalidStorageProvider;